import { Injectable } from '@angular/core';
import { AlertModel } from '@itb-monorepo/models';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    private alert$: Subject<AlertModel>;
    private toasts: AlertModel[] = [];

    constructor() {
        this.alert$ = new Subject<AlertModel>();
    }

    showAlert(alert: AlertModel) {
        this.alert$.next(alert);
    }
    showToast(toast: AlertModel, name?: string, single?: boolean) {
        toast.name = name;
        if (single) {
            const t = this.toasts.find(x => x.name == name);
            if (t) {
                return;
            }
        }
        const toastElement = document.createElement('div');
        const toastTitleElement = document.createElement('span');
        const toastBodyElement = document.createElement('div');
        const body = document.createElement('span');
        toastElement.classList.add("toast");
        toastElement.classList.add(`t-${name}`);
        toastElement.classList.add("toast-" + toast.type);
        toastBodyElement.classList.add("toast-body");
        if (toast.title) {
            toastTitleElement.innerText = toast.title;
        }
        body.innerHTML = toast.body;
        toastBodyElement.append(toastTitleElement);
        toastBodyElement.append(body);
        toastElement.append(toastBodyElement);
        toastElement.style.top = '20px';
        document.body.append(toastElement);
        for (let index = 0; index < this.toasts.length; index++) {
            const element = document.querySelectorAll('.toast')[index] as HTMLElement;

            const elementTop = parseInt(element.style.top.replace('px', ''));

            element.style.top = 15 + elementTop + toastElement.clientHeight + 'px';

        }
        this.toasts.push(toast);
        let to;
        if (!toast.static) {
            to = setTimeout(() => {
                this.deleteAlert(toastElement)
            }, 5000);
        }
        toastElement.addEventListener('click', (e) => {
            const currentTarget = e.currentTarget as HTMLElement;
            this.deleteAlert(currentTarget);
            if (to) {
                clearTimeout(to);
            }
        })
    }

    getAlert(): Observable<AlertModel> {
        return this.alert$.asObservable();
    }

    deleteAlert(toastElement: HTMLElement): void {
        const elements = document.querySelectorAll('body > .toast');
        const elementIndex = Array.from(elements).indexOf(toastElement);
        const clientHeight = toastElement.clientHeight;
        toastElement.remove();
        this.toasts.splice(elementIndex);
        for (let i = elementIndex; i >= 0; i--) {
            const element = elements[i] as HTMLElement;
            const elementTop = parseInt(element.style.top.replace('px', ''));
            element.style.top = element.style.top = (elementTop - clientHeight - 15) + 'px';
        }
    }

    deleteByName(name: string): void {
        const elements = document.querySelectorAll('body > .toast');
        const toastElement = document.querySelector(`body > .toast.t-${name}`);
        if (toastElement) {
            const elementIndex = Array.from(elements).indexOf(toastElement);
            const clientHeight = toastElement.clientHeight;
            toastElement.remove();
            this.toasts.splice(elementIndex);
            for (let i = elementIndex; i >= 0; i--) {
                const element = elements[i] as HTMLElement;
                const elementTop = parseInt(element.style.top.replace('px', ''));
                element.style.top = element.style.top = (elementTop - clientHeight - 15) + 'px';
            }
        }

    }
}
